import MetricsPanel from "../../components/MetricsPanel";
import { useAuth } from "../../context/AuthContext";

export default function ClientMetrics() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="space-y-8" data-testid="client-metrics-page">
      <div>
        <div className="tracker text-brand mb-3">[ Progress ]</div>
        <h1 className="font-display text-4xl sm:text-5xl">Metrics.</h1>
        <p className="text-zinc-500 mt-2">Log your weight, body-fat and progress photos. Performance tests live on the Assessment tab.</p>
      </div>
      <MetricsPanel clientId={user.id} clientName={user.name} canEdit={true} mode="client" unit="kg" />
    </div>
  );
}
